import styled from "styled-components"
import breakpoint from "styled-components-breakpoint"
export const Span = styled.span`
  ${breakpoint("tablet")`
    float: right;
    margin-left: 2rem;
  `}

  > button {
    margin-bottom: 2rem;
    width: 100%;
    font-size: 1rem;
    padding: 1rem;

    ${breakpoint("tablet")`
      margin-bottom: 0;
      width: auto;
      font-size: 0.75rem;
      padding: 0.5rem 1rem;
    `}

    &:hover {
      cursor: pointer;
    }
  }
`

export const A = styled.a`
  color: ${(props) => props.theme.colors.primary};
  text-decoration: none;
  cursor: pointer;
`
